// global Informacion
import logoColegio from '../assets/img/logoColegio.png';
import firmaRector from '../assets/img/firmaRector.png';

const globalInformation = {
    colegioNombre: 'INSTITUCION EDUCATIVA EL ASERRÍO',
    colegioNombreCorto: 'I.E. EL ASERRÍO',
    fraseColegio: 'EDUCAR ES CREAR VOLUNTADES',
    telefonoColegio: '3208514432',
    emailColegio: 'ieaserrio@gmail.com',
    direccionColegio: 'AVENIDA DE LA CONSTITUCION S/N',
    logoColegio: logoColegio,
    gobernacion: "GOBERNACIÓN DE NORTE DE SANTANDER",
    secretaria_educacion: "SECRETARÍA DE EDUCACIÓN DEPARTAMENTAL",
    municipio: "MUNICIPIO DE TEORAMA",
    institucion_educativa: "INSTITUCIÓN EDUCATIVA EL ASERRÍO",
    rector: "RAUL JHONEDINSON MARTINEZ SUAREZ",
    firmaRector: firmaRector,
    subdireccion: "SUBDIRECCIÓN DE EDUCACIÓN RURAL",
    decretos: [
      {
        tipo: "DECRETO DE CREACIÓN",
        numero: "000339",
        fecha: "11 DE AGOSTO DE 2004"
      },
      {
        tipo: "DECRETO DE MODIFICACIÓN",
        numero: "007013",
        fecha: "08 DE NOVIEMBRE DE 2023"
      }
    ],
    codigo_dane: "254800000582"
}

export default globalInformation;